import { Chip as MDCChip } from '@material/react-chips';
import PropTypes from 'prop-types';

class Chip extends MDCChip {
	render() {
		return super.render();
	}
}

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/chips#chip
Chip.propTypes = {
	className: PropTypes.string,
	handleInteraction: PropTypes.func,
	handleSelect: PropTypes.func,
	handleTrailingIconInteraction: PropTypes.func,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	leadingIcon: PropTypes.element,
	selected: PropTypes.bool,
	shouldRemoveOnTrailingIconClick: PropTypes.bool,
	trailingIcon: PropTypes.element,
};

export default Chip;
